<template>
  <div
    v-if="matchInfo.homeTeam"
    class="m-prematch-summary"
  >
    <div class="m-tournament">
      <LeagueInfo
        :category="matchInfo.category"
        :category-icon="matchInfo.categoryIcon"
        :tournament="matchInfo.tournament"
        :tournament-id="matchInfo.tournamentId"
        :sport-name="matchInfo.sport"
      />
      <!-- match label -->
      <IconMatchLabels
        class="tw-h-[12px] tw-ml-[5px]"
        :options="{
          configKey: 'commonLabeUrl',
          displayIn: '4',
          sportId: matchInfo.sportId,
          tournamentId: matchInfo.tournamentId,
          eventStatus: matchInfo.status
        }"
      />
    </div>

    <div class="m-teams">
      <div
        class="m-team m-home-team"
        :class="[{ 'm-team-vsoccer':isVSoccer }]"
      >
        {{ matchInfo.homeTeam }}
      </div>
      <span class="m-vs">vs</span>
      <div
        class="m-team m-away-team"
        :class="[{ 'm-team-vsoccer':isVSoccer }]"
      >
        {{ matchInfo.awayTeam }}
      </div>
    </div>

    <div class="m-meta">
      <span class="m-time">{{ showTime }}</span>
      <!-- 直播 -->
      <img
        v-if="isShowLiveTag"
        src="~public/images/play.svg"
        class="label-tag"
        alt=""
      >
    </div>

    <div
      v-if="matchInfo.hasLiveCoverage === 1"
      class="m-meta m-meta-play"
    >
      Live In-Play Available
    </div>
  </div>
</template>

<script>
import useMatchInfo from '@ms/components/match/useMatchInfo.js'
import { getMatchTime } from '@ms/components/match/composables/useMatchTime.js'
import IconMatchLabels from '@ms/components/IconMatchLabels.vue'
import LeagueInfo from '../../components/LeagueInfo'

export default {
  name: 'PrematchSummary',
  components: {
    IconMatchLabels,
    LeagueInfo
  },
  setup() {
    const { matchInfo } = useMatchInfo()
    return {
      matchInfo
    }
  },
  computed: {
    showTime() {
      return getMatchTime(this.matchInfo, 'DD/MM dddd HH:mm')
    },
    // 是否有视频直播
    isShowLiveTag() {
      return this.matchInfo.hasLive && this.matchInfo.bookingStatus.toLowerCase() === 'booked'
    },
    isVSoccer() {
      return this.matchInfo.sportId === 'lv:sport:1'
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~wap/common/style/variable.less");

.m-prematch-summary {
  padding-bottom: 5px;
  border-radius: 0 0 20px 20px;
  margin-bottom: 6px;
  background: #161616;
  box-shadow: 0 0 4px rgba(0, 0, 0, 5%);
  color: #999;
  font-size: 10/@rem;
  line-height: 14/@rem;
  text-align: center;


  .m-tournament {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    background: #222;
    line-height: 40px;
  }

  .meta-league-info {
    & > span {
      .ellipsis();
    }
  }

  .m-teams {
    display: flex;
    min-height: 48px;
    align-items: center;
    justify-content: center;
    margin: 6px 0;
    line-height: 24px;

    .m-team {
      width: 40%;
      color: #fff;
      font-size: 16/@rem;
    }

    .m-team-vsoccer {
      font-size: 20/@rem;
    }

    .m-home-team {
      margin-bottom: 2/@rem;
      text-align: right;
    }

    .m-away-team {
      text-align: left;
    }

    .m-vs {
      margin: 0 19/@rem;
      color: #999;
      font-size: 10/@rem;
    }
  }

  .m-meta {
    margin-top: 10px;
    line-height: 16px;

    & > span,
    i {
      font-size: 12px;
      vertical-align: top;
    }
  }

  .label-tag {
    height: 14px;
    margin: 0 4px;
  }

  .m-meta-play {
    margin-top: 6px;
    font-size: 12px;
    text-align: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .m-prematch-summary {
  background: #fff;
  color: #666;

  .m-tournament {
    background:linear-gradient(180deg,#fff 0%,#f7f7f7 100%);

    .meta-league-info a {
      color: #000;
    }
  }

  .m-teams .m-team { color: #000; }

  .m-teams .m-vs { color: #666; }
}
</style>
